module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l2ZSg"))).then(() => parcelRequire('2KbAe'));